export default __webpack_public_path__ + "static/media/shapes.5027e4d0.PNG";